import React, { useState } from 'react';
import { MapPin, CheckCircle } from 'lucide-react';
import axios from 'axios';

export function HospitalArrivalButton({ appointmentId, patientId, movedBack = false }) {
  const [clicked, setClicked] = useState(false);
  const [status, setStatus] = useState('idle'); // idle, confirming, confirmed, error

  const API = process.env.REACT_APP_BACKEND_URL || 'http://upchaarq.com';

  const handleArrival = async () => {
    setStatus('confirming');
    try {
      const response = await axios.post(
        `${API}/api/attendance/confirm-arrival/${appointmentId}`,
        { patient_id: patientId }
      );

      if (response.data.success) {
        setStatus('confirmed');
        setClicked(true);
      } else {
        setStatus('error');
      }
    } catch (e) {
      console.error('Arrival confirmation error:', e);
      setStatus('error');
    }
  };

  // Not moved back, don't show button
  if (!movedBack) {
    return null;
  }

  if (status === 'confirmed') {
    return (
      <div className="bg-green-100 border-l-4 border-green-600 rounded p-4 animate-pulse">
        <div className="flex items-center gap-3">
          <CheckCircle className="w-6 h-6 text-green-600" />
          <div>
            <p className="text-green-800 font-bold">✅ आपकी उपस्थिति दर्ज हो गई!</p>
            <p className="text-sm text-green-700">डॉक्टर आपको बुलाएंगे</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-blue-50 border-2 border-blue-300 rounded-lg p-6 text-center">
      <MapPin className="w-8 h-8 text-blue-600 mx-auto mb-3" />
      <h3 className="text-lg font-bold text-blue-900 mb-2">
        Hospital आ गए?
      </h3>
      <p className="text-slate-700 mb-4">
        जैसे ही आप hospital में आ जाएं, नीचे button दबा दें
      </p>

      <button
        onClick={handleArrival}
        disabled={status === 'confirming'}
        className={`
          w-full py-3 px-4 rounded-lg font-bold text-white text-lg
          transition duration-200
          ${status === 'confirming'
            ? 'bg-gray-400 cursor-not-allowed'
            : 'bg-blue-600 hover:bg-blue-700 active:scale-95'
          }
        `}
      >
        {status === 'confirming' ? 'प्रतीक्षा करें...' : '🏥 Hospital में आ गया!'}
      </button>

      {status === 'error' && (
        <p className="text-red-600 text-sm mt-3">
          Error: फिर से कोशिश करें
        </p>
      )}

      <p className="text-xs text-slate-500 mt-4">
        ⚠️ यह button तब दिखेगा जब आपने "NO" चुना हो
      </p>
    </div>
  );
}
